import { Types } from '@store/types';

const initialState = {
	response: { data: [] },
	filterField: {},
	countResponse: 0,
	costingDetails: {},
	quoteCount: {},
	activeTabInfo: null,
	updatedCostingItemInfo: {}
};

const CostingReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.SET_COSTING_FILTER_DATA:
			return { ...state, filterField: { ...action.payload } };
		case Types.SET_COSTING_COUNT:
			return { ...state, countResponse: action.payload };
		case Types.FETCH_COSTING_DETAILS:
			return { ...state, costingDetails: action.payload };
		case Types.FETCH_ALL_QUOTE_REQUEST_BY_STATUS: {
			let data = [];
			if (action.payload.merge === true) {
				data = [...state.response.data, ...action.payload.data.data];
			} else {
				data = [...action.payload.data.data];
			}
			let response = action.payload.data;
			response.data = data;
			return { ...state, response: response };
		}
		case Types.SET_QUONT_COUNT:
			return { ...state, quoteCount: action.payload };
		case Types.SET_ACTIVE_TAB_INFO:
			return {
				...state,
				activeTabInfo: action.payload
			};
		case Types.UPDATE_COSTING_ITEM_INFO:
			return {
				...state,
				updatedCostingItemInfo: action.payload
			};
		case Types.CLEAR_COSTING:
			return {
				...state,
				response: { data: [] },
				filterField: {},
				countResponse: 0,
				costingDetails: {},
				quoteCount: {},
				activeTabInfo: null
			};
		default:
			return state;
	}
};

export default CostingReducer;
